var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.557 6.33027L25.807 0.0802734C25.4852 -0.0267578 25.1398 -0.0267578 24.818 0.0802734L6.06797 6.33027C5.43047 6.54277 5 7.13965 5 7.8123V29.6873C5 43.1584 24.0094 49.6498 24.818 49.9193C24.9789 49.9732 25.1453 49.9998 25.3125 49.9998C25.4797 49.9998 25.6461 49.9732 25.807 49.9193C26.6156 49.6498 45.625 43.1584 45.625 29.6873V7.8123C45.625 7.13965 45.1945 6.54277 44.557 6.33027Z",
    fill: "url(#paint0_linear_5746_6213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8268 6.05246L38.7865 10.3721C39.4474 10.5932 39.8937 11.2112 39.8937 11.9094V29.9186C39.8937 37.2805 29.2238 42.4789 25.9539 43.8972C25.7482 43.9863 25.5287 44.0309 25.3092 44.0309C25.0913 44.0309 24.8734 43.9871 24.6693 43.8996C21.4002 42.4935 10.7344 37.3323 10.7344 29.9186V11.9094C10.7344 11.2112 11.1807 10.5932 11.8416 10.3721L24.8013 6.05246C25.135 5.9415 25.493 5.9415 25.8268 6.05246ZM25.4068 22.9804L25.1621 27.0499H26.3859V31.6088C26.3859 31.7108 26.335 31.7618 26.233 31.7618H24.3971C24.2951 31.7618 24.2441 31.7108 24.2441 31.6088V18.3908C24.2441 18.2888 24.2951 18.2378 24.3971 18.2378H26.233C26.335 18.2378 26.3859 18.2888 26.3859 18.3908V21.114L30.5472 21.5729V18.5438C30.5472 16.9731 30.2004 15.8512 29.5069 15.1781C28.8337 14.505 27.7118 14.1684 26.1412 14.1684H24.4889C22.9183 14.1684 21.7862 14.505 21.0926 15.1781C20.4195 15.8512 20.0829 16.9731 20.0829 18.5438V31.4559C20.0829 33.0061 20.4195 34.128 21.0926 34.8216C21.7862 35.4947 22.9183 35.8313 24.4889 35.8313H26.1412C27.7118 35.8313 28.8337 35.4947 29.5069 34.8216C30.2004 34.128 30.5472 33.0061 30.5472 31.4559V22.9804H25.4068Z",
    fill: "url(#paint1_linear_5746_6213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5746_6213",
    x1: 7.97109,
    y1: 38.8795,
    x2: 42.6555,
    y2: 4.19434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0099,
    stopColor: "#2A4D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688BAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5746_6213",
    x1: 12.4062,
    y1: 35.3543,
    x2: 38.2089,
    y2: 9.55239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.56df3013d3993fadbd95e8de57291787.svg";
export { ForwardRef as ReactComponent };